import { createSvgIcon } from '@mui/material/utils';
import React, { memo } from 'react';

const SvgIcon = createSvgIcon(
  <g transform='translate(0.000000,24.000000) scale(0.100000,-0.100000)' fill='#000000' stroke='none'>
    <path d='M30 175 c0 -24 5 -35 15 -35 8 0 15 9 15 20 0 13 7 20 20 20 11 0 20 7 20 15 0 10 -11 15 -35 15 -33 0 -35 -2 -35 -35z' />
    <path d='M140 195 c0 -8 9 -15 20 -15 13 0 20 -7 20 -20 0 -11 7 -20 15 -20 10 0 15 11 15 35 0 33 -2 35 -35 35 -24 0 -35 -5 -35 -15z' />
    <path d='M30 65 c0 -33 2 -35 35 -35 24 0 35 5 35 15 0 8 -9 15 -20 15 -13 0 -20 7 -20 20 0 11 -7 20 -15 20 -10 0 -15 -11 -15 -35z' />
    <path d='M180 80 c0 -13 -7 -20 -20 -20 -11 0 -20 -7 -20 -15 0 -10 11 -15 35 -15 33 0 35 2 35 35 0 24 -5 35 -15 35 -8 0 -15 -9 -15 -20z' />
  </g>,
  'Maximize'
);

const MaximizeIcon = function (props) {
  return <SvgIcon {...props} />;
};

export default memo(MaximizeIcon);
